module.exports = __webpack_public_path__ + "img/punto-12.dcdc8313.png";